exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-space{padding-left:35px}.card-tools{text-align:center;width:100%}.page-select{width:110px}", ""]);

// exports
